import { Transition } from "@headlessui/react";
import React, { useState, useRef, useEffect } from "react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";

const AutoCompleteSelect = ({ label, data, details, setDetails }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [query, setQuery] = useState("");
  const fruits = data;
  const [selected, setSelected] = useState(null);

  const menuRef = useRef();

  const filteredFruits = fruits.filter((fruit) => {
    if (label === "Company Name")
      return fruit?.company_name
        ?.toLowerCase()
        .includes(inputValue?.toLowerCase());
    if (label === "Job Profile")
      return fruit?.job_title
        ?.toLowerCase()
        ?.includes(inputValue?.toLowerCase());
    if (label === "Location" || label==="Firm Location")
      return fruit?.city?.toLowerCase()?.includes(inputValue?.toLowerCase());
    if (label === "Current Location" || label === "Vendor Current Location")
      return fruit?.city?.toLowerCase()?.includes(inputValue?.toLowerCase());
    if (label === "Account type") {
      return fruit?.type?.toLowerCase()?.includes(inputValue?.toLowerCase());
    }
  });

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsDropdownOpen(value.length > 0); // Open dropdown only if input value is not empty
    // setSelected(-1);
    if (label === "Company Name") {
      setDetails({ ...details, company_Name: value });
    }
    if (label === "Job Profile") {
      setDetails({ ...details, job_Profile: value });
    }
    if (label === "Location" || label==="Firm Location") {
      setDetails({ ...details, location: value });
    }
    if (label === "Current Location") {
      setDetails({ ...details, location: value });
    }
    if (label === "Vendor Current Location") {
      setDetails({ ...details, vendor_location: value });
    }
    if (label === "Account type") {
      setDetails({
        ...details,
        accountDetails: {
          ...details?.accountDetails,
          account_type: value,
        },
      });
    }
  };

  const handleDropdownItemClick = (fruit, index) => {
    let value = "";
    if (label === "Company Name") {
      value = fruit?.company_name;
      setDetails({ ...details, company_Name: fruit });
    }
    if (label === "Job Profile") {
      value = fruit?.job_title;
      setDetails({ ...details, job_Profile: fruit });
    }
    if (label === "Location" || label==="Firm Location") {
      value = fruit?.city + ", " + fruit?.state;
      setDetails({ ...details, location: fruit });
    }
    if (label === "Current Location") {
      value = fruit?.city + ", " + fruit?.state;
      setDetails({ ...details, location: fruit });
    }
    if (label === "Vendor Current Location") {
      setDetails({ ...details, vendor_location: fruit });
    }
    if (label === "Account type") {
      setDetails({
        ...details,
        accountDetails: {
          ...details?.accountDetails,
          account_type: fruit,
        },
      });
    }

    setInputValue(value);
    setIsDropdownOpen(false);
    setSelected(index);
  };

  function getValue() {
    if (label === "Company Name") return details?.company_Name?.company_name;
    if (label === "Job Profile") return details?.job_Profile?.job_title;
    if (label === "Location"||label ==="Firm Location") {
      const city = details?.location?.city;
      const state = details?.location?.state;
      return city && state ? city + ", " + state : inputValue;
    }
    if (label === "Current Location") {
      const city = details?.location?.city ?? "";
      const state = details?.location?.state ?? "";
      return city && state ? city + ", " + state : inputValue;
    }
    if (label === "Vendor Current Location") {
      const city = details?.vendor_location?.city ?? "";
      const state = details?.vendor_location?.state ?? "";
      return city && state ? city + ", " + state : inputValue;
    }
    if (label === "Account type")
      return details?.accountDetails?.account_type?.type;
  }

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  return (
    <div className="h-fit  ">
      <div className="w-full">
        <label style={{ fontFamily: "gilRoy-semibold" }} className="text-sm  ">
          {label}
        </label>
        <div className="relative mt-[10px]" ref={menuRef}>
          <div className="relative w-full cursor-default overflow-hidden rounded-[10px] bg-white text-left  focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 ">
            <input
              className="w-full  h-[45px]  bg-white  border-[1.5px] border-[#CBD5E1] rounded-[10px] focus:border-none m-0  pl-3 pr-10 text-[14px] leading-5 text-balck focus:ring-0  "
              type="text"
              id="autocomplete-input"
              onClick={() =>
                setIsDropdownOpen((isDropdownOpen) => !isDropdownOpen)
              }
              value={getValue()}
              onChange={handleInputChange}
            />
            <button
              className="absolute inset-y-0 right-0 flex items-center pr-2 "
              onClick={() =>
                setIsDropdownOpen((isDropdownOpen) => !isDropdownOpen)
              }
            >
              <ChevronDownIcon
                className="h-5 w-5 text-[#6C757D]"
                aria-hidden="true"
              />
            </button>
          </div>

          <ul
            //ref={menuRef}
            style={{ boxShadow: "0px 0px 4px 0px #00000040" }}
            className={` absolute w-[99%] bg-white mt-2 ml-1 mr-2 overflow-y-auto z-40  rounded-lg ${
              isDropdownOpen ? "max-h-60" : "max-h-0"
            } `}
          >
            {filteredFruits.map((fruit, index) => {
              let value = "";
              if (label === "Company Name") value = fruit?.company_name;
              if (label === "Job Profile") value = fruit?.job_title;
              if (label === "Location" || label ==="Firm Location")
                value = fruit?.city + ", " + fruit?.state;
              if (label === "Current Location")
                value = fruit?.city + ", " + fruit?.state;
              if (label === "Vendor Current Location")
                value = fruit?.city + ", " + fruit?.state;
              if (label === "Account type") value = fruit?.type;

              return selected === index ? (
                <li
                  key={index}
                  className="p-2 text-sm cursor-pointer  hover:bg-[#2563EB] hover:text-white"
                  onClick={() => handleDropdownItemClick(fruit, index)}
                >
                  {" "}
                  {value}
                </li>
              ) : (
                <li
                  key={index}
                  className="p-2 text-sm cursor-pointer  hover:bg-[#2563EB] hover:text-white"
                  onClick={() => handleDropdownItemClick(fruit, index)}
                >
                  {value}
                </li>
              );
            })}

            {/* //className="absolute z-50 mt-1 max-h-60 w-full overflow-auto
            rounded-md bg-white py-1 text-base drop-shadow-md ring-1 ring-white
            ring-opacity-5 focus:outline-none sm:text-sm" */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AutoCompleteSelect;
